import { render, staticRenderFns } from "./StepInitialResumeCreation.vue?vue&type=template&id=6d297f3f&scoped=true&"
import script from "./StepInitialResumeCreation.vue?vue&type=script&lang=js&"
export * from "./StepInitialResumeCreation.vue?vue&type=script&lang=js&"
import style0 from "./StepInitialResumeCreation.vue?vue&type=style&index=0&id=6d297f3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d297f3f",
  null
  
)

export default component.exports